module.exports = __webpack_public_path__ + "img/klinik.a18757d8.png";